import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {StateService} from '../../state.service';
import {UserSignUp} from '../../model/userSignUp.model';

@Component({
    selector: 'app-sign-up',
    templateUrl: './sign-up.component.html',
    styleUrls: ['./sign-up.component.css'],
    standalone: false
})
export class SignUpComponent {

  user = new UserSignUp();
  submitted = false;

  constructor(private route: ActivatedRoute, private router: Router, private stateService: StateService) {}

  onSubmit() {
    const password = this.user.password;
    delete this.user.password;
    delete this.user.passwordConfirm;
    this.stateService.addUser(this.user, password);
    this.submitted = true;
    this.router.navigate( ['user']);
  }
}
